'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _class, _class2, _temp; /**
                                          * Created by zfc on 2016/10/24.
                                          */

// import { Link } from 'react-router';
// import Modal from 'react-modal';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _serviceOrderConfirm = require('redux/modules/serviceOrderConfirm');

var serviceOrderConfirmActions = _interopRequireWildcard(_serviceOrderConfirm);

var _reduxAsyncConnect = require('redux-async-connect');

var _components = require('components');

var _background = require('redux/modules/background');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServiceOrderConfirm = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var dispatch = _ref.store.dispatch;
    var params = _ref.params;

    var promises = [];
    // console.log(params);
    promises.push(dispatch((0, _background.changeHeaderText)('服务订单确认')));
    promises.push(dispatch(serviceOrderConfirmActions.load(params.serviceOrderId)));
    return _promise2.default.all(promises);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    data: state.serviceOrderConfirm.data
  };
}, (0, _extends3.default)({}, serviceOrderConfirmActions, {
  routerPush: _reactRouterRedux.push
})), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ServiceOrderConfirm, _Component);

  function ServiceOrderConfirm() {
    (0, _classCallCheck3.default)(this, ServiceOrderConfirm);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(ServiceOrderConfirm).call(this));

    _this.state = {
      isAgreeTipModalOpened: false
    };
    return _this;
  }

  (0, _createClass3.default)(ServiceOrderConfirm, [{
    key: 'onAgreeTipModelClose',
    value: function onAgreeTipModelClose() {
      // console.log(this.state.isAgreeTipModalOpened);
      this.setState({
        isAgreeTipModalOpened: false
      });
    }
  }, {
    key: 'onSubmitBtn',
    value: function onSubmitBtn(submitInfo) {
      var _props = this.props;
      var submit = _props.submit;
      var routerPush = _props.routerPush;
      var data = _props.data;
      // console.log(data);
      // console.log(submitInfo);

      if (submit && data) {
        switch (data.serviceOrderConfirmInfo[0].orderStatus) {
          case '待审核':
            this.setState({
              isAgreeTipModalOpened: true
            });
            // console.log(this.state.isAgreeTipModalOpened);
            break;
          case '待确认':
            submit((0, _extends3.default)({}, data.serviceOrderConfirmInfo[0], submitInfo),
            /* isExpress: submitInfo.isExpress,
             consignee: submitInfo.consignee,
             consigneePhone: submitInfo.consigneePhone,
             address: submitInfo.address,
             isInvoice: submitInfo.isInvoice,
             invoiceText: submitInfo.invoiceText,
             projectType: submitInfo.projectType*/
            data.orderNumber).then(function (nextData) {
              if (nextData.isValid) {
                routerPush('/payment/' + nextData.payNumber + '/' + nextData.activeId);
              }
            });
            break;
          case '待支付':
            routerPush('/payment/' + data.orderNumber + '/' + data.activeId);
            break;
          default:
          // console.log(data.serviceOrderConfirmInfo[0].orderStatus);
        }
      }
    }

    /*  fieldChange(val, field) {
     const {fieldChange, data, params} = this.props;
     if (data && data.info instanceof Array && data.info.length > 0) {
     const info = {...data.serviceOrderConfirmInfo[0]};
     info[field] = val;
     fieldChange(info, field, params.serviceOrderId);
     }
     }*/

  }, {
    key: 'analysisServiceOrderBuyInfo',
    value: function analysisServiceOrderBuyInfo() {
      var data = this.props.data;

      var serviceConfirmDiv = _react2.default.createElement('div', null);
      if (data) {
        var serviceOrderConfirmInfo = data.serviceOrderConfirmInfo;
        var serviceOrderConfirmInfoError = data.serviceOrderConfirmInfoError;

        if (serviceOrderConfirmInfoError) {
          serviceConfirmDiv = _react2.default.createElement(_components.ErrorLabel, { error: serviceOrderConfirmInfoError });
        } else if (serviceOrderConfirmInfo && serviceOrderConfirmInfo.length > 0) {
          serviceConfirmDiv = _react2.default.createElement(_components.ServiceOrderConfirmComponent
          // fieldChange={this.fieldChange.bind(this)}
          , { initialValues: { isExpress: serviceOrderConfirmInfo[0].isExpress, consignee: '', consigneePhone: '', address: '', isInvoice: serviceOrderConfirmInfo[0].isInvoice, invoiceText: '', projectType: serviceOrderConfirmInfo[0].projectType },
            onSubmit: this.onSubmitBtn.bind(this),
            serviceOrderConfirmData: serviceOrderConfirmInfo[0] });
        }
      }
      return serviceConfirmDiv;
    }
  }, {
    key: 'render',
    value: function render() {
      /*
       const {styles} = require('./ServiceOrderConfirm.scss');
       const {data} = this.props;
        let serviceConfirmTotalMessageDiv = <div></div>;
       if (data) {
       const {serviceOrderConfirmInfo} = data;
       if (serviceOrderConfirmInfo && serviceOrderConfirmInfo.length > 0) {
       serviceConfirmTotalMessageDiv = (
       <div className={styles.boa} onClick={this.onSubmit.bind(this)}>
       <div className={styles.jin}>订单总额：{serviceOrderConfirmInfo.info[0].sumMoney}</div>
       <div className={styles.dui}><img src="http://tupian.goeasy.cn:9999/yipinwang/yuxuan/duia.png" alt=""/>
       </div>
       <div className={styles.din}>生成订单</div>
       </div>
       );
       }
       }
       console.log(serviceConfirmTotalMessageDiv);
       */
      var styles = require('./ServiceOrderConfirm.scss');
      var isAgreeTipModalOpened = this.state.isAgreeTipModalOpened;
      /* const allCustomStyle2 = {
       content: {
       background: '#ffffff',
       overflow: 'hidden',
       outline: 'none',
       zIndex: 9999,
       border: '0',
       borderRadius: '30px',
       boxShadow: '3px 2px 20px',
       bottom: 'auto',
       minHeight: '10rem',
       left: '50%',
       padding: '2rem 0px',
       position: 'fixed',
       right: 'auto',
       top: '50%',
       transform: 'translate(-50%,-50%)',
       minWidth: '20rem',
       width: '40rem',
       maxWidth: '60rem'
       }
       };*/

      return _react2.default.createElement(
        'div',
        { className: styles.confirmComponent },
        this.analysisServiceOrderBuyInfo()
        /*
         <Modal style={allCustomStyle2} isOpen={isAgreeTipModalOpened}>
         <div className={styles.modalTitle}><img onClick={this.onAgreeTipModelClose.bind(this)}
         src="http://tupian.goeasy.cn:9999/yipinwang/register/regsiter-icon-cha.png"/>
         </div>
         <div className={styles.submittedSucess}>
         <img src="http://tupian.goeasy.cn:9999/yipinwang/logo.png" alt=""/>
         <p className={styles.submittedSucessTit}>艺品网提醒您</p>
         <p className={styles.submittedSucessContent}>订单还在审核中</p>
         </div>
         </Modal> */,
        _react2.default.createElement(_components.AttentionSuccessModal, { isOpened: isAgreeTipModalOpened,
          loginStyle: { background: 'url("http://tupian.goeasy.cn:9999/yipinwang/wbg/zhuce_sucess_1.png") no-repeat' },
          closeModalFunc: this.onAgreeTipModelClose.bind(this),
          text: '订单还在审核中' })
      );
    }
  }]);
  return ServiceOrderConfirm;
}(_react.Component), _class2.propTypes = {
  data: _react.PropTypes.object,
  load: _react.PropTypes.func,
  fieldChange: _react.PropTypes.func,
  isLoaded: _react.PropTypes.func,
  submit: _react.PropTypes.func,
  routerPush: _react.PropTypes.func,
  dispatch: _react.PropTypes.func,
  params: _react.PropTypes.object
}, _temp)) || _class) || _class);
exports.default = ServiceOrderConfirm;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/ServiceOrderConfirm/ServiceOrderConfirm.js
 ** module id = 1536
 ** module chunks = 0
 **/